import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  auth,
  deleteImage,
  deleteImages,
  deletePlant,
  getArchivedPlants,
  logout,
  updatePlant,
} from '../../api/firebase';
import ModalCarousal from '../UI/ModalCarousal';
import ArchivedPlantList from './archive-dashboard/ArchivedPlantList';
import Footer from './Footer';

const ArchivedPlants = (props) => {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [isLoggedin, setLoggedin] = useState(false);

  const [fetchedPlants, setFetchedPlants] = useState([]);
  const [allowDelete, setAllowDelete] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [selectedImages, setSelectedImages] = useState([]);
  const [openCarousal, setOpenCarousal] = useState(false);

  const logoutUser = async () => {
    setLoading(true);
    try {
      await logout();
    } catch (e) {
      toast.error(e.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const goToHome = () => {
    navigate('/');
  };

  const fetchPlants = async (areaId) => {
    const plants = [];
    setLoading(true);
    try {
      const receivedPlantsSnapShot = await getArchivedPlants(areaId);
      receivedPlantsSnapShot.forEach((d) => {
        const doc = d.data();
        plants.push({
          id: d.id,
          name: doc.name,
          description: doc.description,
          scientificName: doc.scientificName,
          images: doc.images,
          areaId: doc.areaId,
          areaName: doc.areaName,
        });
      });
      setFetchedPlants(plants);
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const removeImage = async (img, p) => {
    setLoading(true);
    const index = p.images.findIndex((x) => x.name === img.name);
    if (index > -1) {
      p.images.splice(index, 1); // 2nd parameter means remove one item only
    }

    try {
      await deleteImage(img.name);
      await updatePlant({ images: p.images }, p.id);
      fetchPlants();
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const unArchivePlant = async (plantId) => {
    setLoading(true);
    try {
      await updatePlant({ isArchived: false }, plantId);
      fetchPlants();
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const permanentlyDeletePlant = async (plant) => {
    setLoading(true);
    try {
      if (plant.images.length > 0) {
        await deleteImages(plant.images);
      }
      await deletePlant(plant.id);
      fetchPlants();
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const showImages = (images) => {
    setOpenCarousal(true);
    setSelectedImages(images);
  };

  const closeModal = () => {
    setOpenCarousal(false);
    setSelectedImages([]);
  };

  useEffect(() => {
    if (loading) return;
    if (!user) {
      setLoggedin(false);
      navigate('/');
    }
    setLoggedin(true);
  }, [loading, navigate, user]);

  useEffect(() => {
    fetchPlants();
  }, []);

  return (
    <>
      <ModalCarousal
        open={openCarousal}
        images={selectedImages}
        closeModal={closeModal}
      />
      <section className="text-gray-600 body-font">
        <button
          disabled={isLoading || loading}
          onClick={() => setAllowDelete((prev) => !prev)}
          className="flex mx-auto mt-10 text-gray-500 border-2 border-gray-500 rounded-full py-2 px-2 focus:outline-none hover:text-gray-800 hover:border-gray-800 text-lg"
        >
          {!allowDelete ? 'Allow Delete' : 'Stop Delete'}
        </button>
        <ArchivedPlantList
          isLoading={isLoading || loading}
          fetchedPlants={fetchedPlants}
          isLoggedin={isLoggedin}
          removeImage={removeImage}
          archivePlant={unArchivePlant}
          deletePlant={permanentlyDeletePlant}
          allowDelete={allowDelete}
          showImages={showImages}
        />
        <Footer
          isLoading={isLoading || loading}
          logoutUser={logoutUser}
          goBack={goToHome}
          isLoggedin={isLoggedin}
          showPlants={true}
        />
      </section>
    </>
  );
};

export default ArchivedPlants;
